import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-seq-detail-steps",
  "use": "icon-seq-detail-steps-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-seq-detail-steps\">\n<path d=\"M3.75002 8.99975L3.29702 4.922C3.16727 3.755 4.36877 2.89775 5.43002 3.401L14.388 7.6445C15.5318 8.186 15.5318 9.8135 14.388 10.355L5.43002 14.5985C4.36877 15.101 3.16727 14.2445 3.29702 13.0775L3.75002 8.99975ZM3.75002 8.99975H9.00002\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol